import React, { useState, useEffect } from 'react';
// import { FlatList } from 'react-native-gesture-handler';
import { roundUp } from '../functions/functions';
import Stars from './Stars';
import Price from './Price';
import { FiPlusCircle, FiLogIn } from "react-icons/fi"
import CalendarDetail from './CalendarDetail';
import { useParams,  } from 'react-router-dom';
import {Link} from "react-router-dom"
// import ImagesView from '../components/ImagesView';
import Status from './Status';

import { db, auth } from '../functions/firebaseFunctions'
const months = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

const VenueScreen = ({ route, navigation }) => {
  const [Err, setErr] = useState(null);

  const { venueId, docid } =  useParams()
  const ownerId = auth.currentUser?.uid
  // console.log('docid', docid, 'venueId', venueId, 'ownerId', ownerId)
  const [info, setInfo] = useState(null);
  const [once, setOnce] = useState(true);
  const [venueImgs, setVenueImgs] = useState(null);
  // console.log('info', info)

  const [events, setEvents] = useState(null);
  const [signed, setSigned] = useState(false);

  const [scsMsg, showScsMsg] = useState(false);

  const [rating, setRating] = useState(null);
  const [Rqty, setRqty] = useState(0);

  const [uid, setUid] = useState(null);


  const [countEvents, setCountEvents] = useState(0);
  const [venueBookDates, setVenueBookDates] = useState(null);
  useEffect(() => {
    getData();
    // console.log(getData())
  }, []);
  const getData = () => {
    let UID;
    if (auth.currentUser) {
      UID = auth.currentUser?.uid;
      setSigned(true);
      setUid(UID);
    }
    if (UID) {
      db.collection('events').where('uid', '==', UID)
        .onSnapshot(res => {
          // .get()
          // .then((res)=>{
          if (!res.empty) {

            const eventsLength = res.docs.length;
            const arrEv = [];
            var countEve = 0;
            res.docs.map((eve, index) => {
              let value = eve.data();
              const date = new Date(value.start.toDate());
              const day = date.getDate();
              const now = new Date();
              const end = new Date(value.end.toDate());
              const month = months[date.getMonth()];
              let status;
              let host;
              db.collection('bookings').doc(value.docid).get().then((eve) => {
                if (eve.exists) {
                  host = eve.data().owner;

                  db.collection('bookings').doc(value.docid).collection('ven').doc(ownerId)
                    .get()
                    .then((res) => {
                      const r = res.data();
                      if (res.exists) {
                        const r = res.data();
                        status = r.status;

                      } else {
                        status = null;

                        // status = r.status
                      }

                      // if(r && r.ven && r.ven[ownerId]){status = r.ven[ownerId].status}
                      if (now < end) {
                        countEve++;

                        arrEv.push({
                          // id:key,
                          id: value.docid,
                          name: value.name,
                          type: value.type,
                          day: day,
                          month: month,
                          date: value.start,
                          end: value.end,
                          public: value.public ? true : null,
                          // host:'r.owner',
                          host: host,
                          status: status,
                        });
                        setCountEvents(countEve);
                        // if(countEve==arrEv.length){
                        // if(index+1==eventsLength){
                        setEvents(arrEv);
                        // }

                      }
                    }).catch((err) => {
                      console.log('err vens screen1', err);
                    });
                }
              }).catch((err) => {
                console.log('err vens screen', err);
              });


            });
          }
        });
    }





    db.collection('venue')
      .where('venueId', '==', venueId)
      .onSnapshot((res) => {
        const val = res.docs[0].data();

        if (val) {
          let imgs = [];

          if (val.cover) { imgs.push(val.cover); }
          if (val.image?.length > 0) {
            val.image?.map(x => {
              imgs.push(x);
            });

          }
          setVenueImgs(imgs);
          setInfo(val);
          db.collection('venue')
            .doc(val.docid)
            .collection('events')
            .onSnapshot((eve) => {
              if (!eve.empty) {
                const arr = [];
                let countEvents = 0;
                eve.docs.forEach(e => {

                  arr.push(e.data());
                  countEvents++;
                  if (countEvents == arr.length) {
                    setVenueBookDates(arr);
                  }
                });
              }
            });
        }
      });

    db.collection('ratings').doc('venues').collection(venueId).get().then((res) => {

      if (!res.empty) {
        let Rqty = 0;
        let rating;
        var ratTotal = 0;

        res.docs.map((ve) => {
          Rqty++;
          let value = ve.data();
          ratTotal = ratTotal + value.rating;

        });
        let rat = roundUp(ratTotal / Rqty, 0.1);
        setRqty(Rqty);
        setRating(rat);
      }
    }).catch(err => setErr(err));


  };


  return (
    <div className='EventScreen' >
      <div className="EditVenuePage" style={{alignItems: 'center',  display: 'flex', flexDirection: 'column'}}>
        {console.log('info', info)}
          {info?.cover && <img alt='cover_img'
              src={info?.cover}
              style={{ height: 180, width: '100%', alignSelf: 'center', objectFit: 'cover', }}
          />}
        <div style={{ padding: 10, minWidth: 300, maxWidth: 600, alignSelf: 'center', width: '100%' }}>
          {Err && <div style={{ color: 'red' }}><p style={{ color: 'red' }}>{Err.message}</p></div>}
          {scsMsg == true && <div ><p s>Request is sent</p></div>}
          <div style={{ flexDirection: 'row' }}>
            <div style={{ display: 'flex', flex: 1, justifyContent: 'space-between', marginBlock: 10 }}>
              <p style={{ color: 'white' }}>{info && info.name}</p>
              <Price price={info && info.price} type="day" />
            </div>
            <div style={{ display: 'flex', flex: 1,  justifyContent: 'space-between', marginBlock: 10 }}>
              <p style={{ color: 'var(--ltg)' }}>{info && info.address}</p>
              <Stars  qty={Rqty} offset={rating / 5} id={venueId} />
            </div>
          </div>
          {info && <React.Fragment>
                <hr style={{ borderBottom: '1px solid var(--ltg)', width: '100%', marginBlock: 5 }} />
            <p style={{ textAlign: 'center', color: 'var(--ltg)' }}>{info.desc}</p>
          </React.Fragment>}
        </div>
        <div style={{width: '330px'}}>
          <CalendarDetail venueBookDates={venueBookDates}/>
        </div>
        <div style={{ height: 2, width: '100%', marginTop: 5 }} />
        <div style={{width: '100%', textAlign: 'center'}}>
          {/* {console.log('events', events)} */}
          {events && countEvents == events?.length && <div >
            <p style={ { color: 'white', marginBlockEnd: 5 }}>Your Events:</p>
                      {events.map(item =>
                      {
                        // console.log('item?.status', item?.status, 'item', item)
                        if (item.status) { return(
                            <div style={{display: 'flex', flexDirection: 'column', width: '100%', textAlign: 'center', height: 60 }}>
                                <hr style={{ borderBottom: '1px solid var(--ltg)', width: '100%', marginBlock: 5 }} />
                                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center',}}>
                                  <Link to={`/event/${item.id}`} className='VenueScreenEvents' >
                                    <div key={item?.id} >
                                        <p style={{fontSize: 16, marginInline: 5, color: 'white', marginBlock: 5,  display: 'flex', alignItems: 'center' }}>{item.month} {item.day} - {item.name} -  {item.type} |  <Status status={item.status} style={{marginInline: 10}} /></p>
                                        
                                    </div>
                                    {/* <p style={{ color: 'white', marginInlineEnd: 5, display: 'flex', flexDirection: 'row', height: 24, alignItems: 'center',  marginBlock: 5 }}>{item.month} {item.day} - {item.name}  </p> */}
                                  </Link>
                                </div>
                            </div>
                            )
                            } else {

                              setErr(null);
                              if (venueBookDates) {
            
                                venueBookDates.map(event => {
                                  const start = new Date(event.start.toDate()).valueOf();
                                  const end = new Date(event.end.toDate()).valueOf();
                                  const newEventStart = new Date(item.date).valueOf();
                                  if (newEventStart >= start && newEventStart < end) {
                                    // console.log('iff123');
                                    setErr({ code: 'timeConf', message: "You can't book this venue at for the selectd event because of the time conflict" });
                                  } else {
                                    // console.log('iff123 else');
                                    let update = {};
                                    update = {
                                      venueId: venueId, address: info.address, status: 'Requested',
                                      price: info.price, name: info.name,
                                      docid: ownerId,
                                    };
            
                                    // db.ref(`bookings/${item.id}/ven`)
                                    //imp
                                    db.collection('bookings').doc(item.id).collection('ven').doc(ownerId)
                                      .set(update).then((r) => {
                                        const bookId = {};
                                        bookId[item.id] = 'venues';
            
                                        // db.ref(`access/${ownerId}`)
                                        db.collection('access').doc(ownerId)
                                          .set(bookId, { merge: true }).then(() => {
            
                                            // db.ref(`venues/${venueId}/events/${item.id}`)
                                            db.collection('venue').doc(info.docid).collection('events').doc(item.id)
                                              .set({
                                                start: item.date,
                                                end: item.end,
                                                public: item.public,
                                                name: item.public ? item.name : null,
                                                type: item.public ? item.type : null,
                                                host: item.public ? item.host : null,
                                              }, { merge: true }).then((r) => {
            
                                                showScsMsg(true); setOnce(true);
                                                let arr = [...events];
                                                let indexOfEvent = arr.findIndex(event => event.id == item.id);
                                                arr[indexOfEvent].status = 'Requested';
                                                setEvents(arr);
            
                                                // setEvents(null)
                                              }).catch(e => {
                                                console.log('e', e);
                                                setErr(e);
                                              });
                                          }).catch(e => {
                                            console.log('e', e);
                                            setErr(e);
                                          });
                                      }).catch(e => {
                                        console.log('e', e);
                                        setErr(e);
                                      });
            
            
            
            
                                  }
            
                                });
            
            
                              } else {
            
                                // const update = {}
                                const update = {
                                  venueId: venueId, address: info.address, status: 'Requested',
                                  price: info.price, name: info.name,
                                  docid: ownerId,
                                };
                                // console.log("item id",)
            
            
                                db.collection('bookings').doc(item.id).collection('ven').doc(ownerId).set(update, { merge: true })
                                  .then(() => {
                                    db.collection('access').doc(ownerId).set({ [item.id]: 'venues' }, { merge: true })
                                      .then(() => {
                                        db.collection('venue')
                                          .doc(info.docid)
                                          .collection('events')
                                          .doc(item.id)
                                          // .where('venueId','==',venueId)
                                          .set({
                                            start: item.date,
                                            end: item.end,
                                            public: item.public,
                                            name: item.public ? item.name : null,
                                            type: item.public ? item.type : null,
                                            host: item.public ? item.host : null,
                                          }).then(() => {
                                            let arr = [...events];
                                            let indexOfEvent = arr.findIndex(event => event.id == item.id);
                                            arr[indexOfEvent].status = 'Requested';
                                            setEvents(arr);
            
            
            
                                            showScsMsg(true); setOnce(true);
                                            // setEvents(null)
                                          }).catch(e => { setErr(e); });
                                      }).catch(e => { setErr(e); });
                                  }).catch(e => { setErr(e); });
            
            
            
                              }
                            }
                        }
                      )}
        

            {/* <FlatList data={events}
              keyExtractor={item => item.id}
              renderItem={({ item }) => <div
                style={[styles.listItem, { flexDirection: 'row', alignItems: 'center' }]}
                onClick={() => {

                  if (item?.status) {

                    navigation.navigate('Event', { eventId: item.id, uid: ownerId, type: item.type });
                  } else {

                    setErr(null);
                    if (venueBookDates) {

                      venueBookDates.map(event => {
                        const start = new Date(event.start.toDate()).valueOf();
                        const end = new Date(event.end.toDate()).valueOf();
                        const newEventStart = new Date(item.date).valueOf();
                        if (newEventStart >= start && newEventStart < end) {
                          console.log('iff123');
                          setErr({ code: 'timeConf', message: "You can't book this venue at for the selectd event because of the time conflict" });
                        } else {
                          console.log('iff123 else');
                          let update = {};
                          update = {
                            venueId: venueId, address: info.address, status: 'Requested',
                            price: info.price, name: info.name,
                            docid: ownerId,
                          };

                          // db.ref(`bookings/${item.id}/ven`)
                          //imp
                          db.collection('bookings').doc(item.id).collection('ven').doc(ownerId)
                            .set(update).then((r) => {
                              const bookId = {};
                              bookId[item.id] = 'venues';

                              // db.ref(`access/${ownerId}`)
                              db.collection('access').doc(ownerId)
                                .set(bookId, { merge: true }).then(() => {

                                  // db.ref(`venues/${venueId}/events/${item.id}`)
                                  db.collection('venue').doc(info.docid).collection('events').doc(item.id)
                                    .set({
                                      start: item.date,
                                      end: item.end,
                                      public: item.public,
                                      name: item.public ? item.name : null,
                                      type: item.public ? item.type : null,
                                      host: item.public ? item.host : null,
                                    }, { merge: true }).then((r) => {

                                      showScsMsg(true); setOnce(true);
                                      let arr = [...events];
                                      let indexOfEvent = arr.findIndex(event => event.id == item.id);
                                      arr[indexOfEvent].status = 'Requested';
                                      setEvents(arr);

                                      // setEvents(null)
                                    }).catch(e => {
                                      console.log('e', e);
                                      setErr(e);
                                    });
                                }).catch(e => {
                                  console.log('e', e);
                                  setErr(e);
                                });
                            }).catch(e => {
                              console.log('e', e);
                              setErr(e);
                            });




                        }

                      });


                    } else {

                      // const update = {}
                      const update = {
                        venueId: venueId, address: info.address, status: 'Requested',
                        price: info.price, name: info.name,
                        docid: ownerId,
                      };
                      // console.log("item id",)


                      db.collection('bookings').doc(item.id).collection('ven').doc(ownerId).set(update, { merge: true })
                        .then(() => {
                          db.collection('access').doc(ownerId).set({ [item.id]: 'venues' }, { merge: true })
                            .then(() => {
                              db.collection('venue')
                                .doc(info.docid)
                                .collection('events')
                                .doc(item.id)
                                // .where('venueId','==',venueId)
                                .set({
                                  start: item.date,
                                  end: item.end,
                                  public: item.public,
                                  name: item.public ? item.name : null,
                                  type: item.public ? item.type : null,
                                  host: item.public ? item.host : null,
                                }).then(() => {
                                  let arr = [...events];
                                  let indexOfEvent = arr.findIndex(event => event.id == item.id);
                                  arr[indexOfEvent].status = 'Requested';
                                  setEvents(arr);



                                  showScsMsg(true); setOnce(true);
                                  // setEvents(null)
                                }).catch(e => { setErr(e); });
                            }).catch(e => { setErr(e); });
                        }).catch(e => { setErr(e); });



                    }
                  }
                }}>
                <p style={[styles.listText, { color: 'white' }]}>{item.month} {item.day} - {item.name}  |</p>
                <Status status={item.status} />
              </div>
              } /> */}
          </div>}
          <div style={{display: 'flex', justifyContent: 'center'}}>
            {signed === true && !events && 
              <button  className='BrowseButton'  onClick={() => { console.log('navigation.navigate(Edit Event, { eventId: new, uid: uid });') }}>
                Create an event to book the venu<FiPlusCircle style={{marginInlineStart: '5px'}}/>
              </button>
            }
            {signed === false && 
              <Link to={'/Profile/register'} className='BrowseButton'>
                <p style={{textTransform: 'uppercase'}}>Log in to book the venue</p> <FiLogIn style={{ marginLeft: 15 }} />
              </Link>
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default VenueScreen;
